import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { AuthService, ResolverLoadingService } from 'pbc.angular';

import { IProjektArtsResponse } from 'fa-kt.types';
import { PostProjektArtCommandService } from '../commands';
import { ProjektArtsService } from '../query';

@Injectable({
  providedIn: 'root',
})
export class ProjektArtsPageResolver implements Resolve<IProjektArtsResponse | void> {
  constructor(
    private loading: ResolverLoadingService,
    private authService: AuthService,
    private projektArts: ProjektArtsService,
    private postProjektArt: PostProjektArtCommandService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IProjektArtsResponse | void> {
    this.loading.resolving();
    const log = (error: any) => console.error(error);
    const [projektArts] = await Promise.all([this.projektArts.request({}).catch(log), this.postProjektArt.prepare(true).catch(log)]);
    this.loading.resolved();
    return projektArts;
  }
}
